<template>
  <div :class="['d-flex justify-content-between flex-wrap pl-2 table-actions-live', { sticky: isSticky }]">
    <Checkbox
      :value="checked"
      :part-selected="partSelected.isPartSelected"
      @input="onChecked(false)">
      <div v-if="partSelected.selectedCount === partSelected.length" class="d-inline-flex align-items-center gap-2">
        <span>{{ partSelected.captionAll }}</span>
        <button class="btn btn-link" @click.prevent="onChecked(false)">Unselect</button>
      </div>
      <div v-else class="d-inline-flex align-items-center gap-2">
        <span>{{ partSelected.caption }}</span>
        <button class="btn btn-link" @click.prevent="onChecked(true)">Select All</button>
        <button class="btn btn-link" @click.prevent="onChecked(false)">Unselect</button>
      </div>
    </Checkbox>
    <div class="actions gap-4">
      <button class="btn btn-secondary btn-xs rounded gap-2" :disabled="loadingCsv" @click="$emit('downloadCsv')">
        <span v-if="loadingCsv" class='wrap-icon'><i class="fa-duotone fa-solid fa-spinner-third fa-spin" /></span>
        <span v-else class='wrap-icon'><i class='far fa-file-csv' /></span>
        <span class='text'>CSV</span>
      </button>
    </div>
  </div>
</template>

<script>
import Checkbox from '../../../components/checkbox'

export default {
  components: { Checkbox },
  props: {
    checked: Boolean,
    geogrids: Array,
    tagOptions: Array,
    rowsTotalCount: Number,
    partSelected: Object,
    onlyDeleted: Boolean,
    loadingCsv: Boolean
  },
  data() {
    return {
      isSticky: false
    }
  },
  mounted() {
    const tableActions = document.querySelector('.table-actions')
    if (tableActions) {
      document.addEventListener('scroll', () => {
        this.isSticky = window.scrollY >= tableActions.offsetTop - 1
      })
    }
  },
  methods: {
    onChecked(value) {
      this.$emit('onChecked', value)
    }
  }
}
</script>
